import DiscreetExpeditionEN from './Home/EN/DiscreetExpeditionVisual_EN.webp';
import SiliconeQualityDocumentEN from './Home/EN/SiliconeQualityDocument_EN.webp';
import SiliconeQualityVisualEN from './Home/EN/SiliconeQualityVisual_EN.webp';
import DiscreetExpeditionFR from './Home/FR/DiscreetExpeditionVisual_VF.webp';
import SiliconeQualityDocumentFR from './Home/FR/SiliconeQualityDocument_VF.webp';
import SiliconeQualityVisualFR from './Home/FR/SiliconeQualityVisual_VF.webp';
import SiliconePour from './Home/SiliconePourV2.gif';

import CareGuideEN1 from './CareGuide/EN/CareGuideENB-1.webp';
import CareGuideEN2 from './CareGuide/EN/CareGuideENB-2.webp';
import CareGuideEN3 from './CareGuide/EN/CareGuideENB-3.webp';
import CareGuideEN4 from './CareGuide/EN/CareGuideENB-4.webp';
import CareGuideEN5 from './CareGuide/EN/CareGuideENB-5.webp';
import CareGuideEN6 from './CareGuide/EN/CareGuideENB-6.webp';
import CareGuideFR1 from './CareGuide/FR/CareGuideFRB-1.webp';
import CareGuideFR2 from './CareGuide/FR/CareGuideFRB-2.webp';
import CareGuideFR3 from './CareGuide/FR/CareGuideFRB-3.webp';
import CareGuideFR4 from './CareGuide/FR/CareGuideFRB-4.webp';
import CareGuideFR5 from './CareGuide/FR/CareGuideFRB-5.webp';
import CareGuideFR6 from './CareGuide/FR/CareGuideFRB-6.webp';

export const siliconePourGifUrl = SiliconePour;

export const homeImages = {
    EN: {
        discreetExpedition: DiscreetExpeditionEN,
        siliconeQualityDocument: SiliconeQualityDocumentEN,
        siliconeQualityVisual: SiliconeQualityVisualEN,
    },
    FR: {
        discreetExpedition: DiscreetExpeditionFR,
        siliconeQualityDocument: SiliconeQualityDocumentFR,
        siliconeQualityVisual: SiliconeQualityVisualFR,
    },
};

export const careGuidePages = {
    EN: [CareGuideEN1, CareGuideEN2, CareGuideEN3, CareGuideEN4, CareGuideEN5, CareGuideEN6],
    FR: [CareGuideFR1, CareGuideFR2, CareGuideFR3, CareGuideFR4, CareGuideFR5, CareGuideFR6],
};
